import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DeleteScreenerConfirmationModal from "../DeleteScreenerConfirmationModal";
// import { AuthContext } from "~/root";
   

const SavedScreeners = ({ isOpen, onClose, userId }: any) => {
    const navigate = useNavigate();
    
    const [screeners, setScreeners] = useState([]);
    const [expandedFilters, setExpandedFilters] = useState<{ [key: number]: boolean }>({});
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);
    const [screenerId, setScreenerId] = useState(null);

    
    useEffect(() => {
        axios.get(`/api/user/screeners/${userId}`).then(response => {
            setScreeners(response.data);
        });
    }, [isOpen]);

    const screenerIdeasRunExample = (e: any) => {
        let filters = e.target.dataset.tag;
        let dataArr = filters.split(',').map((s: any) => s.trim());
        const encodedQuery = encodeURIComponent(dataArr.join('and'));
         navigate(`/screener?query=${encodedQuery}`);
       // window.location.href = `/screener?query=${encodedQuery}`;
        onClose(false);
    }

    const deleteSavedScreener = (e: any) => {
        let id = e.target.dataset.id;
        setScreenerId(id);
        setIsDeleteConfirmationOpen(true);
    }

    return (
        <div>
            {
                screeners.length > 0 ? (
                    <div className="space-y-6">
                        {screeners.map((idea: any, ideaIndex: any) => (
                            <div key={ideaIndex} className="p-2 text-left border border-gray-200 transition-colors w-full mt-3 block hover:bg-blue-50 rounded-lg">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <span className="p-1 w-9 h-9">
                                            {"💡"}
                                        </span>
                                        <span className="text-xs md:text-sm font-semibold text-gray-900">{idea.name}</span>
                                        
                                    </div>
                                    <div className="flex items-center">
                                        <button className="ml-2 text-red-500 hover:text-red-700 mx-auto" >
                                            <i className="fas fa-trash-alt" data-id={idea.id} onClick={deleteSavedScreener}></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="flex flex-wrap mt-2">

                                    {idea.display_arr.slice(0, expandedFilters[ideaIndex] ? idea.display_arr.length : 2).map((filter: any, index: any) => (
                                        <span key={index} className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-[10px] lg:text-[11px] font-medium text-green-700 ring-1 ring-inset ring-green-600/20 m-1">
                                            {filter}
                                        </span>
                                    ))}
                                    {!expandedFilters[ideaIndex] && idea.display_arr.length > 2 && (
                                        <button
                                            onClick={() => setExpandedFilters(prev => ({ ...prev, [ideaIndex]: true }))}
                                            className="text-xs font-semibold text-green-500 underline ms-1"
                                        >
                                            {idea.display_arr.length - 2} more
                                        </button>
                                    )}

                                    <button className="font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 whitespace-nowrap border border-gray-800 rounded-3xl text-white bg-black hover:bg-gray-800 focus:ring-black px-2 py-0 text-xs ms-auto" data-tag={idea.display_arr} onClick={screenerIdeasRunExample}>Apply</button>



                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center text-gray-500">No saved screeners found</div>
                )
            }
            {
                isDeleteConfirmationOpen && (
                    <DeleteScreenerConfirmationModal isOpen={isDeleteConfirmationOpen} onClose={setIsDeleteConfirmationOpen} screenerId={screenerId} />
                )
            }
        </div>
    );
};

export default SavedScreeners;